module.exports = __webpack_public_path__ + "img/thumbnail_Wolverine_j_normal.f66ee832.png";